import type { OasDocument3XExtended } from '@ipfabric/utils';
import { getXTableOas } from './getXTableOas';

export const getSnColumns = (
  oas: OasDocument3XExtended,
  apiEndpoint: string,
) => {
  const snColumns = getXTableOas(oas, apiEndpoint)
    ?.columns?.filter((column) => column.isDeviceSn)
    .map((column) => column.key);

  return snColumns ?? [];
};
